/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
import themeProject from './cfg/theme.json';

import { green } from '@material-ui/core/colors';

let appPalette = themeProject.palette

const theme = M.createMuiTheme({
//  palette: appPalette,
palette: {    
  primary: { light: "rgba(69, 139, 0, 0.5)", main: "#458B00", dark: '#69b076' },    //light: green[50]
  secondary: { light: "rgb(232, 240, 254)", main: "#3a87ad", dark: "#005a7e" },    
  error: { main: "rgb(244, 67, 54)" },
  text: { secondary: "#555" }  
},
breakpoints: {
  
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: { "xs": 0, "lg": 1280, "sm": 900, "xl": 1920, "md": 1300 }
  
},
  //palette : themeProject.palette,
  typography: {
/*?? */
//   useNextVariants: true, 
  },
  overrides: {
    MuiListItem: {
      button: {
        color: "#458B00"
      }
    },
    MuiBadge: {
      colorSecondary: {
        backgroundColor: "lightseagreen"
      }
    },
    MuiTableCell: {
	  root: {
		  padding: "14px 5px 14px 16px"
	  }
    },
	MuiOutlinedInput:{
      root: {
        backgroundColor: "white"
      },
      input:{
        padding: "8px 14px",
        textAlign: "center",
        fontWeight: "bold",  
      },
      notchedOutline: {
        borderColor: "rgba(69, 139, 0, 0.5)",
      },
	  multiline:{
		padding: "6px 0 7px"
	}
  },
  MuiSelect:{
    selectMenu:{
      fontWeight: 400
    }
  },
  MuiButton: {
    root: {
      textTransform: "none" as "none"
    }
  },
  MuiCheckbox: {
    root: {
      color: "#458B00"
    }
  }
  },
 }
)
  
/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default theme
    